import { createSelector } from 'reselect';
import { E_PERMISSION_KEY } from 'src/services/auth/types/permissionsTypes';
var authState = function (state) { return state.auth; };
export var getIsAuth = createSelector(authState, function (state) { return state.isAuth; });
export var getAccessToken = createSelector(authState, function (state) { return state.accessToken; });
export var getUserInfo = createSelector(authState, function (state) { return state.userInfo; });
export var getPermissions = createSelector([authState], function (state) { return state.permissions; });
export var getIsCasesViewAllowed = createSelector([getPermissions], function (permissions) {
    var _a, _b;
    if (!permissions) {
        return false;
    }
    var isFiltersAllowed = (_a = permissions[E_PERMISSION_KEY.CASE_SEARCH_FILTERS_VIEW]) === null || _a === void 0 ? void 0 : _a.allowed;
    var isResultsAllowed = (_b = permissions[E_PERMISSION_KEY.CASE_SEARCH_RESULTS_VIEW]) === null || _b === void 0 ? void 0 : _b.allowed;
    return isFiltersAllowed || isResultsAllowed;
});
export var getAutoPlayPermission = createSelector([getPermissions], function (permissions) {
    var _a;
    return (_a = permissions === null || permissions === void 0 ? void 0 : permissions[E_PERMISSION_KEY.CASE_SEARCH_AUTO_PLAY_PERFORM]) === null || _a === void 0 ? void 0 : _a.allowed;
});
export var getGroups = createSelector(authState, function (state) { return state.groups; });
export var getCommentsPermission = createSelector(getPermissions, function (permission) {
    if (!permission) {
        return true; // true is default behavior
    }
    var commentPermission = permission[E_PERMISSION_KEY.CASE_GLOBAL_VIEW_DISPLAY_COMMENT_MODULE];
    return commentPermission ? commentPermission.allowed : true; // true is default behavior
});
export var getUsersImportPermission = createSelector(getPermissions, function (permission) {
    var _a;
    if (!permission) {
        return false;
    }
    return ((_a = permission[E_PERMISSION_KEY.USER_MANAGEMENT_IMPORT]) === null || _a === void 0 ? void 0 : _a.allowed) || false;
});
